module.exports = __webpack_public_path__ + "img/image_placeholder_squared.a17ad7ec.jpg";